module.exports = __webpack_public_path__ + "media/click_excited.bd4bc8d7.mp3";